import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, retry, tap } from 'rxjs/operators';
import { MainService } from 'src/app/app.service';


@Injectable({
  providedIn: 'root'
})
export class ChatbotService {

  constructor(private http: HttpClient, private mainsService: MainService) { }

  private get chatHttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${this.mainsService.userToken.token}`
      })
    };
  }

  enviarPergunta(pergunta: string) {
    return this.http.post<any>('/chatbot/chat', { content: pergunta }, this.chatHttpOptions)
    .pipe(
      retry(3),
      map(resposta => {
          return resposta;
      }),
      catchError(this.mainsService.handleError));
  }
}
